@if (fieldSet.includes(field)) {
  <div class="row">
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-6 col-md-4 mb-1">
          <label [for]="'diseaseHistory' + translationGroup">{{
            'serviceData.form.' + translationGroup + '.historyLabel' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-6 col-md-8">
          <div class="form-check form-check-inline form-check-lg">
            <input
              class="form-check-input me-2"
              type="radio"
              formControlName="hasHistory"
              [attr.data-cy]="field + '-radio-yes'"
              [id]="'diseaseHistoryYes' + translationGroup"
              [value]="true"
            />
            <label
              class="form-check-label"
              [for]="'diseaseHistoryYes' + translationGroup"
            >
              {{ 'common.yes' | translate }}
            </label>
          </div>
          <div class="form-check form-check-inline form-check-lg">
            <input
              class="form-check-input me-2"
              type="radio"
              formControlName="hasHistory"
              [attr.data-cy]="field + '-radio-no'"
              [id]="'diseaseHistoryNo' + translationGroup"
              [value]="false"
            />
            <label
              class="form-check-label"
              [for]="'diseaseHistoryNo' + translationGroup"
            >
              {{ 'common.no' | translate }}
            </label>
          </div>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-6 col-md-8">
          <app-validation-error
            for="hasHistory"
            translations="validation.generic"
            [attr.data-cy]="field + '-validation-error'"
          ></app-validation-error>
        </div>
      </div>
    </div>
  </div>
  @if (form.get('hasHistory').value) {
    <div class="row">
      <div class="col-12 col-sm-2 mb-1">
        <label for="diseaseConditionDescription">{{
          'serviceData.form.' + translationGroup + '.diseaseLabel' | translate
        }}</label>
      </div>
      <div class="col-10 col-sm-9">
        <div class="row">
          <div [ngClass]="getColumnClass()">
            <div class="row align-items-center mb-3">
              <div class="col-12">
                <div class="d-flex">
                  <input
                    class="form-control"
                    id="diseaseConditionDescription"
                    [formControl]="conditionDescriptionFormControl"
                    [placeholder]="
                      'serviceData.form.placeholders.diseaseInformation'
                        | translate
                    "
                    [attr.data-cy]="field + 'Description-input'"
                  />
                </div>
              </div>
            </div>
          </div>
          @if (relationToPatient) {
            <div [ngClass]="getColumnClass()">
              <div class="row align-items-center justify-content-end mb-3">
                <div class="col-12">
                  <div class="d-flex">
                    <input
                      class="form-control"
                      [formControl]="relationToPatientFormControl"
                      [placeholder]="
                        'serviceData.form.placeholders.relationToPatient'
                          | translate
                      "
                      [attr.data-cy]="field + 'RelationToPatient-input'"
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          @if (ageOfOnset) {
            <div [ngClass]="getColumnClass()">
              <div class="row align-items-center justify-content-end mb-3">
                <div class="col-12">
                  <div class="d-flex">
                    <input
                      class="form-control"
                      type="number"
                      [attr.data-cy]="field + 'AgeOfOnset-input'"
                      [formControl]="ageOfOnsetFormControl"
                      [placeholder]="
                        'serviceData.form.placeholders.ageOfOnset' | translate
                      "
                    />
                  </div>
                </div>
                @if (ageOfOnsetFormControl.errors) {
                  @if (ageOfOnsetFormControl.errors.min) {
                    <div
                      class="pt-1 pb-2"
                      [attr.data-cy]="field + 'AgeOfOnset-validation-error'"
                    >
                      <span class="text-danger caption">
                        {{ 'validation.diseaseHistory.min' | translate }}
                      </span>
                    </div>
                  }
                  @if (ageOfOnsetFormControl.errors.max) {
                    <div
                      class="pt-1 pb-2"
                      [attr.data-cy]="field + 'AgeOfOnset-validation-error'"
                    >
                      <span class="text-danger caption">
                        {{ 'validation.diseaseHistory.max' | translate }}
                      </span>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
        <app-validation-error
          translations="validation.diseaseHistory"
          [attr.data-cy]="field + 'Description-validation-error'"
        ></app-validation-error>
      </div>
      <div class="col-1">
        <button
          class="icon-btn icon-btn-lg"
          ngbTooltip="{{
            'serviceData.form.tooltips.' + translationGroup | translate
          }}"
          triggers="hover"
          placement="left"
          [disabled]="isAddButtonDisabled()"
          (click)="addDisease()"
          [attr.data-cy]="field + '-add-disease-btn'"
        >
          <i class="fa-light fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="row justify-content-end mb-3">
      <div class="col-12 col-md-10">
        <app-data-table [configuration]="diseaseConfiguration" />
      </div>
    </div>
  }
}
